<template>
  <div id="contenedor-listado-documentos-expediente-mobile">
    <v-list>
      <template v-for="item in listadoDocumentosExpedienteContrato">
        <v-list-group
          v-if="item.documentos.length > 0"
          :key="`tipo-${item.tipo}-${item.index}`"
          v-model="item.mostrarDocumentos"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.tipo }}
                  <v-chip
                  class="mx-4"
                  color="info">
                    {{`${getDocumentosIntegrados(item.documentos)} / ${item.documentos.length}`}}
                  </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            class="px-6"
            v-for="(documento, index) in item.documentos"
            :key="`documento-${documento.descripcion}-${index}`"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                documento.documento.descripcion
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <template v-if="!documento.publicKey">
                <v-btn v-if="!soloLectura" icon @click="editarDocumentoExpediente(documento)">
                  <v-icon color="success"> mdi-file-plus-outline </v-icon>
                </v-btn>
              </template>
              <template v-else>
                <v-btn icon @click="mostrarOpciones(documento)">
                  <v-icon> mdi-dots-horizontal </v-icon>
                </v-btn>
              </template>
            </v-list-item-action>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
    <v-dialog
    v-if="documentoOpciones" v-model="mostrarVentanaOpciones"
    :width="!$vuetify.breakpoint.xs ? '400' : '90%'">
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-row>
            <v-col md="6">
              <v-row justify="center">
                <v-btn
                  x-large
                  color="success"
                  @click="verDocumentoExpediente(documentoOpciones)"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </v-row>
            </v-col>
            <v-col md="6">
              <v-row justify="center">
                <v-btn
                  x-large
                  color="blue darken-1"
                  @click="descargarDocumentoExpediente(documentoOpciones)"
                >
                  <v-icon color="white"> mdi-cloud-download </v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="!soloLectura">
            <v-col md="6">
              <v-row justify="center">
                <v-btn
                  x-large
                  color="warning"
                  @click="editarDocumentoExpediente(documentoOpciones)"
                >
                  <v-icon> mdi-pencil </v-icon>
                </v-btn>
              </v-row>
            </v-col>
            <v-col md="6">
              <v-row justify="center">
                <v-btn
                  x-large
                  color="red"
                  @click="borrarDocumentoExpediente(documentoOpciones)"
                >
                  <v-icon color="white">mdi-delete</v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoDocumentosExpedienteMobile',
  mixins: [mixDescargarArchivo],
  props: {
    listadoDocumentosExpedienteContrato: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      mostrarVentanaOpciones: false,
      documentoOpciones: null,
    };
  },
  methods: {
    getDocumentosIntegrados(documentos) {
      const documentosIntegrados = documentos.filter((documento) => documento.publicKey);
      return documentosIntegrados.length;
    },
    cerrarVentanaOpciones() {
      this.mostrarVentanaOpciones = false;
      this.documentoOpciones = null;
    },
    mostrarOpciones(documento) {
      this.documentoOpciones = documento;
      this.mostrarVentanaOpciones = true;
    },
    editarDocumentoExpediente(documentoExpediente) {
      eventBus.$emit('editar-documento-expediente', documentoExpediente);
    },
    borrarDocumentoExpediente(documentoExpediente) {
      eventBus.$emit('borrar-documento-expediente', documentoExpediente);
    },
    verDocumentoExpediente(documentoExpediente) {
      eventBus.$emit('ver-documento-expediente', documentoExpediente);
    },
    descargarDocumentoExpediente(documentoExpediente) {
      const documento = documentoExpediente;
      const etapa = this.setEtapa(documentoExpediente.documento.etapa);
      documento.etapa = etapa;
      this.mixDescargarArchivo(documentoExpediente, 'expedientes');
    },
    setEtapa(etapa) {
      if (etapa === 1) return 'AE';
      if (etapa === 2) return 'EJ';
      if (etapa === 3) return 'DE';
      return 'N/A';
    },
    getSoloIdDocumentos(documentos) {
      return documentos.map(({ idDocumento }) => idDocumento);
    },
  },
};
</script>

<style>
</style>
